import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Main from './components/Main/Main';
import { Notification } from './components/Messages/Notification';
import IdleTimerContainer from './components/Misc/IdleTimerContainer';
import Login from '../src/pages/Login/Login';
import LoginAuthCode from '../src/pages/Login/LoginAuthCode';
import Loginuser from './pages/Loginuser/Loginuser';
import ForgotPassword from './pages/public/ForgotPassword';
import DownloadMonthlyStatement from '../src/pages/External/MonthlyStatement/DownloadMonthlyStatement';
import Register from '../src/pages/Registration/Register/Register';
import Registration from './pages/Registration/AccountRegistration/Registration';
import PageNotFound from '../src/pages/PageNotFound/PageNotFound';
import Verification from '../src/pages/Verification/Verification';
import authSvc from './services/AuthService';
import Impersonate from '../src/pages/Impersonate/Impersonate';
import { PageContextProvider } from './context/PageContext';

function App() {
  const [user, setUser] = React.useState({});
  const [pages, setPages] = React.useState([]);
  const [landingPage, setLandingPage] = React.useState('');

  React.useEffect(() => {
    try {
      const u = authSvc.getCurrentUser();
      setUser(u);
      if (['Master Account', 'Counterparty', 'User'].includes(u?.UserType)) {
        setLandingPage('/app/bank-summary');
      } else {
        setLandingPage('/app/dashboard');
      }

      const pages = authSvc.getPages();
      setPages(pages);
    } catch (error) {
      console.error(error);
    }
  }, []);

  const isAuthenticated = () => {
    return user && user.Username;
  };

  const PrivateRoute = function ({ addPageContext, component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (isAuthenticated()) {
            const element = React.createElement(component, {
              ...props,
              user: user,
              pages: pages,
            });

            if (addPageContext) {
              return React.createElement(PageContextProvider, {}, element);
            }

            return element;
          }

          if (props.location.search) {
            sessionStorage.setItem(
              'search',
              props.location.search.substring(1, props.location.search.length)
            );
          }

          return (
            <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
          );
        }}
      />
    );
  };

  const PublicRoute = function ({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={(props) => {
          if (!isAuthenticated()) {
            if (
              props.location.pathname === '/login-auth-code' &&
              props.history.action !== 'PUSH'
            ) {
              return (
                <Redirect
                  to={{
                    pathname: '/login',
                  }}
                />
              );
            }

            return React.createElement(component, props);
          }

          const searchQuery = sessionStorage.getItem('search');
          sessionStorage.removeItem('search');

          return (
            <Redirect
              to={{
                pathname: props.location?.state?.from?.pathname || '/',
                search: searchQuery || '',
              }}
            />
          );
        }}
      />
    );
  };

  return (
    <React.Fragment>
      {isAuthenticated() && <IdleTimerContainer />}
      <Switch>
        <Route exact path="/" render={() => <Redirect to={landingPage} />} />
        <Route exact path="/app" render={() => <Redirect to={landingPage} />} />
        <Route
          exact
          path="/external/download/monthly-statement/:year/:month/:accountId/:email"
          component={DownloadMonthlyStatement}
        />
        <PrivateRoute path="/app" component={Main} addPageContext />
        <PublicRoute path="/login" component={Login} />
        <PublicRoute path="/forgot-password" component={ForgotPassword} />
        <PublicRoute path="/login-auth-code" component={LoginAuthCode} />
        <Route
          path="/register/:verfied?"
          render={(props) => <Register params={{ ...props }} />}
        />
        <Route
          path="/registration/:form?/:key?"
          render={(props) => <Registration params={{ ...props }} />}
        />
        <Route
          path="/impersonate"
          render={(props) => <Impersonate params={{ ...props }} />}
        />
        <Route
          path="/loginuser"
          render={(props) => <Loginuser params={{ ...props }} />}
        />
        <PublicRoute exact path="/verification" component={Verification} />
        <Route path="/*" component={PageNotFound} />
        <Route component={Error} />
      </Switch>
      <Notification />
    </React.Fragment>
  );
}

export default App;
